import { DefaultSeoProps } from 'next-seo'

import { PROD_URL } from 'server/config'

const title = 'MetaMask Developer Dashboard: Your Gateway to Building and Scaling Web3 Dapps'

const defaultSEOProps: DefaultSeoProps = {
  additionalMetaTags: [
    {
      content: 'width=device-width, initial-scale=1, shrink-to-fit=no',
      property: 'viewport'
    }
  ],
  description: `Empowering developers to build powerful dapps. Connect to RPC via Infura, explore APIs and SDKs, and create unique Web3-native experiences.`,
  openGraph: {
    images: [
      {
        alt: 'Metamask Developer Platform',
        height: 630,
        url: 'https://images.ctfassets.net/6g6hg01fg28j/4Aq626mTTzlIfmmJKG4tSq/c41ff93755a4ef31c5550033c8446c2d/MM_Website___Share_Image___Developer___Home_2x__1_.png',
        width: 1200
      }
    ],
    locale: 'en_US',
    site_name: 'MetaMask Developer Dashboard',
    title,
    type: 'website',
    url: PROD_URL
  },
  title,
  twitter: {
    // site: '@site',
    cardType: 'summary_large_image',

    handle: '@metamask'
  }
}

export default defaultSEOProps
